import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Title } from '../../style';
import NotSentDrawer from './drawer/NotSentDrawer';
import CourseDrawer from '../../course/drawer/courseDrawer';
import { openDrawer as openCourseDrawer } from '../../course/courseActions';
import MergeCommandsDrawer from '../../mergeCommands/drawer/MergeCommandsDrawer';
import EnhancedTable from './table/EnhancedTable';
import SelectedCommands from '../selectedCommands/SelectedCommands';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

/**
 * Composant principale englobant toute la partie colis prêt
 * @param {Object} history                         History en provencance du withRouter permettant la navigation
 * @param {Object} currentCourse                   Object représentant la course en cours, si elle existe
 * @param {Array} checkedCommandsIds               Liste des commandes sélectionné
 * @param {Array} searchCommands                   Liste des commandes récupérer du serveur
 * @param {function} dispatchOpenCourseDrawer      Ouvre le course drawer
 */
const NotSent = ({
  history,
  currentCourse,
  checkedCommandsIds,
  dispatchOpenCourseDrawer,
  searchCommands
}) => (
  <div>
    <Grid container spacing={10} alignItems="center">
      <Grid item md={3}>
        <Title>Colis prêts</Title>
      </Grid>
      <Grid item md={9}>
        <SelectedCommands />
        {checkedCommandsIds.length === 0 && (
          <ButtonContainer>
            {searchCommands.length ? (
              <Button
                variant="contained"
                color="primary"
                onClick={() => dispatchOpenCourseDrawer({ allCommands: true })}
              >
                {currentCourse
                  ? 'Ajouter toutes les commandes à la course en cours'
                  : 'Demander le traitement de toutes les commandes'}
              </Button>
            ) : null}

            <Button
              style={{ marginLeft: 24 }}
              variant="contained"
              color="primary"
              onClick={() => history.push('/import-commands')}
            >
              Importer des commandes
            </Button>
          </ButtonContainer>
        )}
      </Grid>
    </Grid>
    <NotSentDrawer />
    <CourseDrawer />
    <MergeCommandsDrawer />
    <EnhancedTable />
  </div>
);

const mapStateToProps = state => ({
  checkedCommandsIds: state.commands.checkedCommandsIds,
  searchCommands: state.commands.searchCommands,
  currentCourse: state.init.currentCourse
});

const mapDispatchToProps = dispatch => ({
  dispatchOpenCourseDrawer: params => dispatch(openCourseDrawer(params))
});

NotSent.propTypes = {
  history: PropTypes.object.isRequired,
  checkedCommandsIds: PropTypes.array.isRequired,
  currentCourse: PropTypes.object,
  searchCommands: PropTypes.array,
  dispatchOpenCourseDrawer: PropTypes.func.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(NotSent));
